import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { FinancialDocument } from 'src/features/financialDocuments/utils/types';

const RESOURCE = '/financial-documents/financial-document/:documentId/issue/';

type MutationFnType = typeof mutationFn;

interface DTO {
    documentId: string;
}

const mutationFn = ({ documentId }: DTO): Promise<FinancialDocument> => {
    return axios.post(formatResourcePath(RESOURCE, { documentId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useIssueFinancialDocument };
